import React from 'react';
import { useState } from 'react';
import {
    Navbar,
    Container,
    Nav,
    NavDropdown,
    Button,
} from 'react-bootstrap';
import { useNavigate, NavLink } from 'react-router-dom';
import brandLogo from '../../assets/icons/Agilisium new logo .png';
import ResourcePulseHubLogo from '../../assets/logo/ResourcePulseHubWhite.png';
import { useSelector } from 'react-redux';
import HubSpoc from '../hubspoc/HubSpoc';
import api from '../../api';
import * as XLSX from "xlsx";
import { toastr } from 'react-redux-toastr';

function ResourcePulseHubNavBar({ hubId }) {
    const [show, setShow] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const navigate = useNavigate();
    const authState = useSelector((state) => state.authUser);
    const role_id = authState?.profile?.role?.role_id;
    const userRoles = authState?.userRoles || [];
    
    const hasRole = (roleId) => userRoles.some(role => role.role_id === roleId);

    const handleClose = (dropdown) => {
        setShow(false);
        setActiveDropdown(dropdown);
    };

    const downloadAsExcel = (csvString, filename = 'Employees.xlsx') => {
        const rows = csvString
            .trim()
            .split('\n')
            .map(row =>
                row
                    .match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g)
                    .map(cell => cell.replace(/^"|"$/g, '').replace(/""/g, '"'))
            );

        const worksheet = XLSX.utils.aoa_to_sheet(rows);

        // Apply styles (bold header, left-align, and keep everything as text)
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                const cell = worksheet[cellAddress];
                if (!cell) continue;

                cell.t = 's'; // force string
                cell.s = {
                    font: R === 0 ? { bold: true } : {},
                    alignment: { horizontal: 'left' },
                };
            }
        }

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Employees');
        XLSX.writeFile(workbook, filename, { cellStyles: true });
        toastr.success('Report downloaded Successfully')
    };

    const downloadAllDump = async () => {
        try {
            toastr.info("Download will begin shortly!");
            const request = { resource: 'api/zoho/downloadAllEmployeesCSV' };
            const response = await api.ZohoService.downloadAllEmployeesCSV(request);
            downloadAsExcel(response.data, "Employees.xlsx")

        } catch (error) {
            console.log(error);
        } finally {
        }
    }

    return (
        <>
            <Navbar
                expand="lg"
                className="bg-body-tertiary p-0"
                expanded={show}
                style={{ position: 'fixed', width: '100%', zIndex: '999', padding: '100px !important' }}
            >
                <Container
                    fluid
                    style={{
                        background: '#FFF',
                    }}
                    className="bg-white p-1 border border-gray-400 "
                >
                    <Navbar.Brand
                        className="brand"
                        onClick={() => { navigate('/resourcePulseHub'); handleClose('home') }}
                    >
                        <img
                            src={brandLogo}
                            alt="brand"
                            style={{
                                top: '19px',
                                left: '48px',
                                height: '58px',
                                // background: 'white 0% 0% no-repeat padding-box',
                                opacity: '1',
                                cursor: 'pointer',
                            }}
                        />
                    </Navbar.Brand>

                    <Navbar.Toggle
                        aria-controls="phNavbarScroll"
                        onClick={() => setShow(!show)}
                    />
                    <Navbar.Collapse id="phNavbarScroll">
                        <Nav
                            className="me-auto my-2 my-lg-0"
                            // style={{ maxHeight: '100px' }}
                            navbarScroll
                        >
                            {(hasRole(17) || hasRole(11)) &&
                                <Nav.Link
                                    as={NavLink}
                                    to="/resourcePulseHub"
                                    className={`px-4 navHeader ${activeDropdown === 'home' ? 'active' : ''}`}
                                    onClick={() => handleClose('home')}
                                >
                                    Home
                                </Nav.Link>
                            }
                            {(hasRole(17) || hasRole(11)) &&
                                <Nav.Link
                                    as={NavLink}
                                    to="/benchResourceFilterPage"
                                    className={`px-4 navHeader ${activeDropdown === 'flexTeam' ? 'active' : ''}`}
                                    onClick={() => handleClose('flexTeam')}
                                >
                                    Flex Team
                                </Nav.Link>
                            }
                            {(hasRole(17) || hasRole(11)) &&
                                <Nav.Link
                                    as={NavLink}
                                    to="/futureFlexResourceFilterPage"
                                    className={`px-4 navHeader ${activeDropdown === 'futureflexTeam' ? 'active' : ''}`}
                                    onClick={() => handleClose('futureflexTeam')}
                                >
                                    Future Flex Team
                                </Nav.Link>
                            }
                            {(hasRole(17) || hasRole(11)) && (
                                <NavDropdown
                                    title={
                                        hasRole(17) ? "Admin" : "Viewer"
                                    }
                                    id="navbarScrollingDropdown"
                                    className={`px-4 navHeader ${activeDropdown === 'admin' ? 'active' : ''}`}
                                >
                                    <NavDropdown.Item
                                        as={NavLink}
                                        to="/associateDetails"
                                        className="bg-transparent menulink"
                                        onClick={() => handleClose('admin')}
                                    >
                                        View My Profile
                                    </NavDropdown.Item>

                                    {(hasRole(17)) && (
                                        <>
                                            <NavDropdown.Divider className='divider' />
                                            <NavDropdown.Item
                                                as={NavLink}
                                                to="/resourcePulseHub"
                                                className="bg-transparent menulinkdownload"
                                                onClick={() => { downloadAllDump() }}
                                            >
                                                Download All Employees Report
                                            </NavDropdown.Item>
                                        </>
                                    )}
                                </NavDropdown>
                            )}
                            <NavLink>
                                <HubSpoc hubId={hubId} />
                            </NavLink>
                        </Nav>
                    </Navbar.Collapse>

                    <Navbar.Brand
                        className="brand"
                        onClick={() => navigate('/')}
                    >
                        <Button className='backtohomebtn'>Go to Agilisium Page</Button>
                    </Navbar.Brand>
                </Container>
            </Navbar>
        </>
    );
}

export default ResourcePulseHubNavBar